import { warmAmbient, worldMapOf } from '@goodtime/engine';

/** The overview has begun to glide into a world's map: start its ambient
 *  files, so they arrive while the camera flies. */
export function warmWorldMap(world: number): void {
  const spec = worldMapOf(world);
  if (spec?.ambient) warmAmbient(spec.ambient, spec.ambientFiles ?? []);
}
